// extracted by mini-css-extract-plugin
module.exports = {"font":"Fonts-module--font--Aj0vJ","selected":"Fonts-module--selected--2dqps"};